import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const SidebarContainer = styled(Box)(({ theme }) => ({
  width: 280,
  height: '100vh',
  backgroundColor: theme.palette.background.paper,
  borderRight: 1,
  borderColor: 'divider',
  display: 'flex',
  flexDirection: 'column',
  position: 'fixed',
  zIndex: theme.zIndex.drawer,
}));

const HeaderSkeleton = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
  color: 'white',
  textAlign: 'center',
}));

const MenuSkeleton = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  flexGrow: 1,
}));

const FooterSkeleton = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: 1,
  borderColor: 'divider',
}));

export const SidebarLoader: React.FC = () => {
  return (
    <SidebarContainer>
      {/* Header */}
      <HeaderSkeleton>
        <Skeleton variant="circular" width={40} height={40} sx={{ mx: 'auto', mb: 1 }} />
        <Skeleton variant="text" width="80%" height={32} sx={{ mx: 'auto', mb: 0.5 }} />
        <Skeleton variant="text" width="60%" height={20} sx={{ mx: 'auto' }} />
      </HeaderSkeleton>

      {/* User Info */}
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
          <Box sx={{ flexGrow: 1 }}>
            <Skeleton variant="text" width="70%" height={20} />
            <Skeleton variant="text" width="50%" height={16} />
          </Box>
        </Box>
      </Box>

      {/* Menu Items */}
      <MenuSkeleton>
        {[1, 2, 3, 4, 5].map((item) => (
          <Box key={item} sx={{ mb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', p: 1 }}>
              <Skeleton variant="circular" width={24} height={24} sx={{ mr: 2 }} />
              <Skeleton variant="text" width="60%" height={20} />
            </Box>
          </Box>
        ))}
      </MenuSkeleton>

      {/* Footer */}
      <FooterSkeleton>
        <Skeleton variant="text" width="100%" height={16} sx={{ mb: 0.5 }} />
        <Skeleton variant="text" width="80%" height={16} />
      </FooterSkeleton>
    </SidebarContainer>
  );
};

export default SidebarLoader; 